import { Box, Typography } from '@mui/material'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import HomeLayout from '../../components/layout-components/HomeLayout'
import AppContext from '../../config/AppContext'
import ActivePlan from '../../components/subscription-component/ActivePlan';
import '../../components/subscription-component/style/Container.scss';
import CancelledPlan from '../../components/subscription-component/CancelledPlan'
import ExpiredPlan from '../../components/subscription-component/ExpiredPlan'
import OnHoldPlan from '../../components/subscription-component/OnHoldPlan';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import CommonUtil from '../../util/CommonUtils'
import { sidebarContext } from '../../util/context'
import NoActivePlan from '../../components/subscription-component/NoActivePlan'
import SubTitleBar from '../../components/subscription-component/SubTitleBar'

const Container = () => {
    const { t, i18n } = useTranslation();
    const { mode } = useContext(AppContext);
    const navigate = useNavigate();
    const { subscriptionDetails } = useContext(sidebarContext);
    const firstNav = useRef(null);
    const secondNav = useRef(null);
    const location = useLocation();
    const [navigation, setNavigation] = useState("compare-plan");
    const [indicatorPosition, setIndicatorPosition] = useState({
        left: 0,
        width: 0
    });

    if (!CommonUtil.isEmptyString(localStorage.getItem("token"))) {
        if (!["OWNER", "MANAGER"].includes(CommonUtil.getRoleCode())) 
            window.location.replace("/page-not-found");
        if (subscriptionDetails?.plan?.trialPlan && tabsUrl[0].links.includes(location.pathname)) {
            window.location.replace("/subscription-manage");
        }
    }

    useEffect(() => {
        if (tabsUrl[0].links.includes(location.pathname)) {
            setIndicatorPosition({
                left: firstNav.current?.offsetLeft || 0,
                width: firstNav.current?.offsetWidth || 0
            });
        } else if (tabsUrl[1].links.includes(location.pathname)) {
            setIndicatorPosition({
                left: secondNav.current?.offsetLeft || 0,
                width: secondNav.current?.offsetWidth || 0
            });
        }
    }, [location.pathname, subscriptionDetails, secondNav.current, i18n.language]);

    return (
        <>
            <>
                <Box className="subscription-main">
                    <Box>
                        <Box className="subscription-header">
                            <Box sx={{
                                display: 'flex',
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                            }}>
                                <Typography className="title-text text-truncate">{t("RAL0783")}</Typography>

                                {subscriptionDetails?.status == "live" && <ActivePlan
                                    planName={subscriptionDetails?.plan?.name}
                                    renewalDate={subscriptionDetails?.plan?.trialPlan == true ? t("RAL1009")
                                        + CommonUtil.formateDateWithNameLocale(subscriptionDetails?.expiresAt) : t("RAL1010")
                                    + CommonUtil.formateDateWithNameLocale(subscriptionDetails?.nextBillingAt)}
                                />}

                                {/* if user is using free trail plan and status got expire then this wills show for other plan not */}
                                {((subscriptionDetails?.status === "cancelled" ||
                                    subscriptionDetails?.status === "non_renewing") &&
                                    new Date(subscriptionDetails?.expiresAt) > new Date()) &&
                                    <CancelledPlan
                                        planName={subscriptionDetails?.plan?.name}
                                        renewalDate={(new Date(subscriptionDetails?.expiresAt) > new Date() ? t("RAL1008") : t("RAL1037"))+" "
                                            + CommonUtil.formateDateWithNameLocale(subscriptionDetails?.expiresAt)}
                                    />}

                                {/* if user is using free trail plan and status got expire then this wills show for other plan not */}
                                {(subscriptionDetails?.plan?.trialPlan == true &&
                                    subscriptionDetails?.status == "expired") && <ExpiredPlan
                                        planName={subscriptionDetails?.plan?.name}
                                        renewalDate={(new Date(subscriptionDetails?.expiresAt) > new Date() ? t("RAL1008") : t("RAL1037"))+" "
                                            + CommonUtil.formateDateWithNameLocale(subscriptionDetails?.expiresAt)}
                                    />}

                                { /* If User has cancelled or non_renewing status and expiring date is lesser than current date then this status will show*/}
                                {((subscriptionDetails?.status == "cancelled" ||
                                    subscriptionDetails?.status == "non_renewing") &&
                                    new Date(subscriptionDetails?.expiresAt) < new Date()) &&
                                    <NoActivePlan
                                        title={t("RAL0830")}
                                        planName={subscriptionDetails?.plan?.name}
                                        renewalDate={(new Date(subscriptionDetails?.expiresAt) > new Date() ? t("RAL1008") : t("RAL1037"))+" "
                                            + CommonUtil.formateDateWithNameLocale(subscriptionDetails?.expiresAt)}
                                    />}
                                { /* If User Card Details has expired then this status will show*/}
                                {subscriptionDetails?.status == "card_expired" && <OnHoldPlan
                                    title={t("RAL0863")}
                                    planName={subscriptionDetails?.plan.name}
                                    renewalDate={(new Date(subscriptionDetails?.expiresAt) > new Date() ? t("RAL1008") : t("RAL1037")) +" "
                                        + CommonUtil.formateDateWithNameLocale(subscriptionDetails?.expiresAt)}
                                />}
                                 {((subscriptionDetails?.plan?.trialPlan == false &&
                                    subscriptionDetails?.status == "expired") &&
                                    new Date(subscriptionDetails?.expiresAt) < new Date()) &&
                                    <NoActivePlan
                                        title={t("RAL0830")}
                                        planName={subscriptionDetails?.plan?.name}
                                        renewalDate={(new Date(subscriptionDetails?.expiresAt) > new Date() ? t("RAL1008") : t("RAL1037"))+" "
                                            + CommonUtil.formateDateWithNameLocale(subscriptionDetails?.expiresAt)}
                                    />}
                            </Box>
                            {/* subscriptionDetails?.plan?.trialPlan == true  */}
                            <Box
                                sx={{
                                    borderBottom: "2px solid",
                                    borderColor: mode === "light" ? "#d9d9d9" : "#313131",
                                    position: "relative",
                                    display: "flex",
                                }}
                            >
                                {subscriptionDetails?.plan?.trialPlan !== true && (
                                    <Typography
                                        sx={{
                                            font: tabsUrl[0].links.includes(location.pathname) ? "normal normal normal 18px/21px GothamMedium !important" : "normal normal normal 18px/21px Gotham !important",
                                            // color: tabsUrl[0].links.includes(location.pathname) ? mode === "dark" ? "#FFF" : "black" :
                                            //     mode === "dark" ? "#f8f8f8cc" : "#242424",
                                            letterSpacing: "0px",
                                            padding: tabsUrl[0].links.includes(location.pathname) ? CommonUtil.getOS() === "MacOS" ? "5px 20px 0px" : "10px 20px" : "10px 20px",
                                            marginRight: "100px",
                                            marginTop: tabsUrl[0].links.includes(location.pathname) ? CommonUtil.getOS() === "MacOS" ? "10px" : "0" : "0",
                                            cursor: "pointer",
                                            // transition: 'all 0.5s ease 0s',
                                            '@media (max-width: 1600px)': {
                                                marginRight: "50px",
                                            },
                                        }}
                                        ref={firstNav}
                                        onClick={() => navigate("/subscription-me")}
                                    >
                                        {t("RAL0826")}
                                    </Typography>
                                )}
                                <Typography
                                    sx={{
                                        font: tabsUrl[1].links.includes(location.pathname) ? "normal normal normal 18px/21px GothamMedium !important" : "normal normal normal 18px/21px Gotham !important",
                                        letterSpacing: "0px",
                                        padding: tabsUrl[1].links.includes(location.pathname) ? CommonUtil.getOS() === "MacOS" ? "5px 20px 0px" : "10px 20px" : "10px 20px",
                                        marginTop: tabsUrl[1].links.includes(location.pathname) ? CommonUtil.getOS() === "MacOS" ? "10px" : "0" : "0",
                                        cursor: "pointer",
                                        // transition: 'all 0.5s ease 0s',
                                    }}
                                    ref={secondNav}
                                    onClick={() => navigate("/subscription-manage")}
                                >
                                    {t("RAL0827")}
                                </Typography>

                                {/* Indicator Box */}
                                <Box
                                    sx={{
                                        position: "absolute",
                                        bottom: "-2px",
                                        left: indicatorPosition.left,
                                        height: "5px",
                                        width: indicatorPosition.width,
                                        background: "#6A5FA2",
                                        transition: 'all 0.5s ease 0s',
                                        zIndex: 2
                                    }}
                                ></Box>
                            </Box>
                        </Box>
                    </Box>
                    <Box className={tabsUrl[1].links.includes(location.pathname) && subscriptionDetails?.plan?.planCode !== "0000"
                        ? "subscription-layout" : "subscription-layout-payment"}>
                        {(window.location.pathname === "/subscription-manage" &&
                            subscriptionDetails?.plan?.planCode !== "0000"
                        ) && <div className="manage-subscription-titlebar">
                                <SubTitleBar navigation={navigation}
                                    setNavigation={setNavigation}
                                />
                            </div>}
                        {tabsUrl[1].links.includes(location.pathname) ? (
                            <div
                                style={{ overflowX: 'auto', height: '100%' }}
                            >

                                <div className={subscriptionDetails?.plan?.planCode !== "0000" ? 'subscription-layout-container' : "subscription-layout-container-free-trail"}>
                                    <Outlet context={{ navigation, setNavigation }} />
                                </div>
                            </div>
                        ) : (
                            <div
                                style={{ position: 'relative', overflow: 'auto', height: '100%' }}
                            >
                                <div className='subscription-layout-container-payment'>
                                    <Outlet context={{ navigation, setNavigation }} />
                                </div>
                            </div>
                        )}
                    </Box>
                </Box>
            </>
        </>
    )
}

export default Container;

const tabsUrl = [{
    title: "Payments & Billings",
    links: ["/subscription-me"]
},
{
    title: "Manage Subscription",
    links: ["/subscription-manage", "/subscription-plans"]
}
]